import React from 'react';

const typeFlat = {
  FLAT: 3, // квартира
  STORAGE: 5, // кладовка
  OFFICE: 7, // офис
};

const typeFlatEnum = [typeFlat.FLAT, typeFlat.OFFICE, typeFlat.STORAGE];

export const getOptionsSelect = ({
  data = [],
  isFlat = false,
  isClient = false,
}) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => ({
    ...item,
    key: item.id,
    value: item.id || item.name,
    content: isFlat
      ? `${
          typeFlatEnum.find((typeId) => typeId === item.typeId)
            ? item.typeShortName
            : ''
        } ${item.name}`
      : isClient
      ? item.fio || item.name || 'Нет данных о клиенте'
      : item.name || item.id,
    search: isClient ? item.fio || item.name : item.name || item.id,
  }));
};

export const getDocOptionsSelectStreet = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data?.map((item) => {
    const city = item.city || null;

    let option = item.name;

    if (city) {
      option = (
        <div>
          <div
            style={{
              lineHeight: 1.1,
              fontSize: 10,
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {city}
          </div>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.name}
          </div>
        </div>
      );
    }

    return {
      ...item,
      key: item.id,
      value: item.id || item.name,
      content: option || item.id,
      search: item.name || String(item.id),
      text: item.name || item.id,
    };
  });
};

const prohibitionStatus = [1, 2]; // На согласовании/Разрешено

const hasDisabledForTransport = (accessInformation = [], isEdit) => {
  if (!accessInformation || accessInformation.length === 0 || isEdit)
    return false;

  return accessInformation.some((item) =>
    prohibitionStatus.includes(item.permit?.permitStatus?.id)
  );
};

export const getOptionsSelectTransports = (transports = [], isEdit) => {
  if (!Array.isArray(transports)) return [];

  return transports?.map((item) => {
    const { transport, accessInformation } = item || {};

    const transportType = transport.transportType.name || null;

    const isDisabled = hasDisabledForTransport(accessInformation, isEdit);

    const ts = `${transport.brand} ${transport.model}, ${transport.number} ${transport.region}`;

    let option = ts;

    if (transportType) {
      option = (
        <div>
          <div
            style={{
              lineHeight: 1.1,
              fontSize: 10,
              fontWeight: 700,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {transportType}
          </div>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {ts}
          </div>
        </div>
      );
    }

    return {
      ...transport,
      key: transport.id,
      value: transport.id,
      content: option || transport.id,
      search: transport.number || transport.id,
      text: ts || transport.id,
      disabled: isDisabled,
    };
  });
};
